const deepMerge = (target, source) => {
    for (const key of Object.keys(source)) {
        if (source[key] instanceof Object && key in target) {
            deepMerge(target[key], source[key]);
        } else {
            target[key] = source[key];
        }
    }
    return target;
};


export const getSxStyle = (theme, func, props) => {
    let finalStyle = {};

    for (const prop of props) {
        const styleToMerge = func(theme)[prop];
        if (styleToMerge) {
            finalStyle = deepMerge(finalStyle, styleToMerge);
        }
    }

    return finalStyle;
};


export const getBaseSxStyle = (object, props) => {
    let finalStyle = {};

    for (const prop of props) {
        if (object[prop]) {
            finalStyle = deepMerge(finalStyle, object[prop]);
        }
    }

    return finalStyle;
};

export const getKeyArray = (data) => {
    const keys = Object.keys(data);
    const values = Object.values(data);

    const final = [];

    for (let i = 0; i < keys.length; i++) {
        if (values[i]) {
            final.push(keys[i]);
        };
    };

    return final;
};